import {
  ActionReducerMapBuilder,
  createAction,
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import axios from "../../axios";
import {
  ResetApiState,
} from "../../redux.type";
import { BusStructure, BusStructureStateTypes } from "./BusStructure.util";

const name = "bus-structure";
const extraActions = createExtraActions();

const BusStructureInitialState: BusStructureStateTypes = {
  structures: ResetApiState([]),
};

/**
 * ACTIONS
 */
function createExtraActions() {
  const getBusStructures = createAsyncThunk<BusStructure[]>(
    `/get-all-${name}`,
    async (data: any, thunkApi) =>
      axios
        .get(`/${name}`, data)
        .then((response) => {
          if (response.data) {
            return response.data;
          } else {
            return thunkApi.rejectWithValue(response?.data);
          }
        })
        .catch((error) => thunkApi.rejectWithValue(error?.response?.data))
  );

  const resetStates = createAction(`/reset-states`);

  return {
    getBusStructures,
    resetStates,
  };
}

/**
 * REDUCERS
 */
function createExtraReducers(
  builder: ActionReducerMapBuilder<BusStructureStateTypes>
) {
  return {
    ...getBusStructureReducer(),
    ...resetStatesReducer(),
  };

  function getBusStructureReducer() {
    return {
      ...builder.addCase(
        extraActions.getBusStructures.pending,
        (state, action) => {
          state.structures = {
            loading: true,
            payload: [],
            successful: false,
            error: null,
          };
        }
      ),
      ...builder.addCase(
        extraActions.getBusStructures.fulfilled,
        (state, action) => {
          state.structures = {
            loading: false,
            payload: action.payload,
            successful: true,
            error: null,
          };
        }
      ),
      ...builder.addCase(
        extraActions.getBusStructures.rejected,
        (state, action) => {
          state.structures = {
            loading: false,
            payload: [],
            successful: false,
            error: action.payload,
          };
        }
      ),
    };
  }

  function resetStatesReducer() {
    return {
      ...builder.addCase(extraActions.resetStates, (state, action) => {
        state.structures = ResetApiState(null);
      }),
    };
  }
}

const BusStructureSlice = createSlice({
  name,
  initialState: BusStructureInitialState,
  reducers: {},
  extraReducers: (builder) => createExtraReducers(builder),
});

export const BusStructureActions = {
  ...BusStructureSlice.actions,
  ...extraActions,
};
export const BusStructureReducer = BusStructureSlice.reducer;
